import {addLocaleData} from 'react-intl';
import load from 'load-script';
import clientLogger, {LOG_ERROR} from './clientLogger';
import {getLanguageFromLocale} from './localization';

export default function loadLocaleData(locale, cb = () => {}) {
    const language = getLanguageFromLocale(locale);
    if (typeof window === 'undefined' || !window.ReactIntlLocaleData) {
        // server side case
        addLocaleData(require(`react-intl/locale-data/${language}`));
        return cb();
    } else if (window.ReactIntlLocaleData[language]) {
        // In the browser, we cheat and use a global. Yay globals!
        addLocaleData(window.ReactIntlLocaleData[language]);
        return cb();
    }

    return load(
        `${window.reactIntlLocaleDataPath}/${language}.js`,
        {attrs: {crossorigin: 'anonymous'}},
        (err) => {
            if (err) {
                clientLogger.captureMessage(
                    `loadLocaleData dynamic load failed err=${err}`,
                    LOG_ERROR
                );
                return cb(err);
            }
            addLocaleData(window.ReactIntlLocaleData[language]);
            return cb();
        }
    );
}
